export default __webpack_public_path__ + "static/media/do.cbd75fee.svg";